"use strict";

exports.__esModule = true;
exports.CalendarToolbar = CalendarToolbar;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Auth = require("../Auth");
var _Core = require("../Core");
var _common = require("../Device/common");
var _DeviceListContext = require("../Device/DeviceListContext");
var _DeviceSelector = require("../Device/DeviceSelector");
var _CalendarContext = require("./CalendarContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function CalendarToolbar(_ref) {
  var selectedDevice = _ref.selectedDevice,
    onSelectDevice = _ref.onSelectDevice;
  var allDevices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_CalendarContext.CalendarContext),
    calendar = _React$useContext2.calendar;
  var scheduleDevices = calendar.schedules.reduce(function (items, schedule) {
    for (var _iterator = _createForOfIteratorHelperLoose(schedule.agendas), _step; !(_step = _iterator()).done;) {
      var agenda = _step.value;
      for (var _iterator2 = _createForOfIteratorHelperLoose(agenda.devices), _step2; !(_step2 = _iterator2()).done;) {
        var uuid = _step2.value;
        items.add(uuid);
      }
    }
    return items;
  }, new Set());
  var devices = allDevices.filter(function (device) {
    return scheduleDevices.has(device.uuid);
  });
  var selectedDeviceName = selectedDevice && ((0, _common.getDevice)(allDevices, selectedDevice) || {
    name: selectedDevice
  }).name;
  return /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_DeviceSelector.DeviceSelector, {
    items: devices,
    selected: selectedDevice ? [(0, _common.getDevice)(allDevices, selectedDevice) || {
      uuid: selectedDevice,
      name: selectedDevice
    }] : [],
    onSelect: function onSelect(selected) {
      return onSelectDevice(selected.length === 0 ? undefined : selected[0].uuid);
    },
    icon: "filter",
    placeholder: selectedDeviceName || translate("CalendarToolbar.DeviceSelectorButton.text", "Select Device")
  }), selectedDevice && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    icon: "time",
    onClick: function onClick() {
      return onSelectDevice(undefined);
    }
  }, translate("CalendarToolbar.plantAgendaButton.text", "Plant Agenda")), /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
    permission: "EDIT_CALENDAR"
  }, function (_ref2) {
    var canEdit = _ref2.isAllowed;
    return /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      style: {
        marginLeft: "auto"
      }
    }, canEdit && /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.ADD,
      to: "/calendar/create-schedule",
      text: translate("CalendarToolbar.createScheduleButton.text", "Create Schedule")
    }), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.LIST,
      to: "/calendar/schedules",
      text: translate("CalendarToolbar.allSchedulesButton.text", "All Schedules")
    }), canEdit && /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.SETTINGS,
      to: "/calendar/settings",
      text: translate("CalendarToolbar.settingsButton.text", "Calendar Settings")
    }));
  }));
}